import produce from 'immer';
import { TLayoutActions, TLayoutsState } from '../../types/redux/layouts';
import { CLEAR_LAYOUT, SET_LAYOUT } from '../actions/layouts';

const initialState: TLayoutsState = {};

export const layouts = (state = initialState, action: TLayoutActions): TLayoutsState => {
    switch (action.type) {
        case CLEAR_LAYOUT: {
            return produce(state, (draft) => {
                delete draft[action.layoutId];
            });
        }
        case SET_LAYOUT: {
            return produce(state, (draft) => {
                // @ts-ignore
                draft[action.layoutId] = action.payload;
            });
        }
        default: {
            return state;
        }
    }
};
